import { SizeUtils } from "../../utils/_SizeUtils";

// https://flaviusmatis.github.io/simplePagination.js
import("simple-pagination.js/jquery.simplePagination");

// import('paginationjs/dist/pagination.css');

/**
 * Pagination class
 */
class Pagination {
    options = {
        nextText: "»",
        prevText: "«",
        ellipsePageSet: false,
        itemsOnPage: 10,
        displayedPages: 3,
        edges: 2,
        hrefTextPrefix: "#P",
        displayedPages: 5,
    };

    added = false;
    destroyed = false;

    /**
     *
     * @param {string} selector pagination container selector
     * @param {Object} tableObj
     * @param {Object | {}} options
     */
    constructor(selector, tableObj, options = {}) {
        this.$elm = $(selector);
        this.table = tableObj;
        if (Object.keys(options).length > 0) {
            for (const op_key in options) {
                if (op_key in options) {
                    this.options[op_key] = options[op_key];
                }
            }
        }

        const window_width = SizeUtils.windowWidth();
        if (+window_width < 768) {
            this.options.edges = 0;
            this.options.displayedPages = 2;
        }
    }

    /**
     *
     * @return {Pagination}
     */
    add() {
        if (!this.added) {
            if ("pagination" in this.$elm) {
                this.$elm.pagination(this.options);
                this.added = true;
            } else {
                import("simple-pagination.js/jquery.simplePagination").then(
                    () => {
                        this.$elm.pagination(this.options);
                        this.added = true;
                    }
                );
            }
        } else {
            if (this.destroyed) {
                this.$elm.pagination("redraw");
            }
        }
        return this;
    }

    /**
     * destroy current pagination
     * @return {Pagination}
     */
    destroy() {
        if (this.added) {
            this.destroyed = true;
            this.$elm.pagination("destroy");
        }
        return this;
    }

    /**
     * Reset pagenumber of current pagination
     */
    resetPageNumber() {
        if ("pagination" in this.$elm) {
            this.$elm.pagination("selectPage", 1);
        } else {
            import("simple-pagination.js/jquery.simplePagination").then(() => {
                this.$elm.pagination("selectPage", 1);
            });
        }
    }

    /**
     *update number of items
     *
     * @param {number} number
     * @memberof Pagination
     */
    updateItems(number) {
        if ("pagination" in this.$elm) {
            this.$elm.pagination("updateItems", number);
        } else {
            import("simple-pagination.js/jquery.simplePagination").then(() => {
                this.$elm.pagination("updateItems", number);
            });
        }
    }
}

export { Pagination };
